const formularyData = (state = {}, action) => {
  switch (action.type) {
  case 'SET_FORMULARY_DATA':
    return action.payload;
  default:
    return state;
  }
};

export default formularyData;
